export enum EOnboardingRoutes {
  ONBOARDING = '/recruiter-onboarding'
}
